const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const ASSET_BASE_URL = (API_BASE_URL || "").replace(/\/api\/?$/, "");

export async function getSignatures() {
  const res = await fetch(`${API_BASE_URL}/signatures`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem("authToken")}`,
    },
  });
  const { data } = await res.json(); // data = array of signature rows

  // Transform array -> { jamie: url, neil: url }
  const map = {};
  (data || []).forEach((sig) => {
    if (sig.signer_id && sig.url) {
      map[sig.signer_id] = sig.url;
    }
  });
  return map;
}